import { createSelector } from 'reselect'
import pick from 'lodash/pick'
import reduce from 'lodash/reduce'
import FETCH_STATUS from './utils/fetchStatus'

const getElementsState = (state) => state.renderElements

const selectModuleIdFromProps = (_, props) => props.elementId;
const selectByIdObject = (state) => getElementsState(state).byIdObject
const selectFetchStatus = (state) => getElementsState(state).fetchStatus
const selectProductBySku = (state) => getElementsState(state).productBySku
const selectFetchStatusBySku = (state) => getElementsState(state).fetchStatusBySku
const selectSkuList = (_, { defaultContent }) => defaultContent ? defaultContent.skuList : []
const selectSkuFromElement = (_, { defaultContent }) => defaultContent ? defaultContent.sku : ''

const createElementFetchStatus = (status) => ({
  fetchStatus: {
    isInitial: !status,
    isRequest: status === FETCH_STATUS.REQUEST,
    isSuccess: status === FETCH_STATUS.SUCCESS,
    isFailure: status === FETCH_STATUS.FAILURE,
  },
})

const createElementFetchStatusBySku = (fetchStatusBySku) => (
  reduce(fetchStatusBySku, (result, status, sku) => ({
    ...result,
    [sku]: {
      isInitial: !status,
      isRequest: status === FETCH_STATUS.REQUEST,
      isSuccess: status === FETCH_STATUS.SUCCESS,
      isFailure: status === FETCH_STATUS.FAILURE,
    },
  }), {})
)

export const makeSelectSingleProduct = () => createSelector(
  [selectSkuFromElement, selectProductBySku, selectFetchStatusBySku],
  (sku, productBySku, fetchStatusBySku) => ({
    product: productBySku[sku] || null,
    ...createElementFetchStatus(fetchStatusBySku[sku]),
  }),
)

export const makeSelectProductList = () => createSelector(
  [selectSkuList, selectProductBySku, selectFetchStatusBySku],
  (skuList, productBySku, fetchStatusBySku) => ({
    products: skuList.map((sku) => productBySku[sku]),
    fetchStatusBySku: createElementFetchStatusBySku(pick(fetchStatusBySku, skuList)),
  }),
)

export const makeSelectMenu = () => createSelector(
  [selectModuleIdFromProps, selectByIdObject, selectFetchStatus],
  (moduleId, byIdObject, fetchStatus) => ({
    menu: byIdObject[moduleId] || null,
    ...createElementFetchStatus(fetchStatus[moduleId]),
  }),
)



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/redux/elementSelectors.js